import _ from 'lodash'
import { Alert } from 'antd'
import { EMPTY_VALUE } from '../../../../../constants/globalTypes'
import Loader from '../../../../Common/Loader'
import { useAtom } from 'jotai'
import { useStepRunState, corsStatusAtom, useStepActions } from '../hooks/useSteps'
import useProposalResult from '../hooks/useProposalResult'
import styles from './ExternalProposalCreateStep.css'
import ExternalErrorStep from './ExternalErrorStep'
import { HyperLink } from '../../../../Common/Form'
import Countdown from '../../../../Common/Countdown/Countdown'

const ExternalProposalCreateStep = () => {
  const { loadingStep, successStep } = useStepRunState()
  const { resetSteps } = useStepActions()
  const [proposalResult] = useProposalResult()
  const [corsStatus] = useAtom(corsStatusAtom)
  const proposalId = _.get(proposalResult, 'payload.id', EMPTY_VALUE)
  const showSuccess = !loadingStep && successStep

  return (
    <ExternalErrorStep>
      <div className={styles.container}>
        {loadingStep && (
          <div className={styles.loadingContent}>
            <Loader
              spinning
              message='建立賣場提案中'
            />
          </div>
        )}
        {showSuccess && (
          <>
            <div className={styles.successContent}>
              <Alert
                type='success'
                showIcon
                message='建立成功'
                description={(
                  <>
                    <p>
                      提案單號：
                      <HyperLink
                        href={`/proposal/newListing/compose?id=${proposalId}`}
                        target='_blank'
                      >
                        {proposalId}
                      </HyperLink>
                    </p>
                  </>
                )}
              />
            </div>
            <div className={styles.successContent}>
              {corsStatus && showSuccess
                ? (
                  <Alert
                    type='warning'
                    showIcon
                    message='現在請關閉 CORS Unblock'
                    description={(
                      <>
                        <p>為了避免瀏覽器異常，請在擷取資料完成後關閉 CORS Unblock 方能繼續提案</p>
                        <p>
                          或
                          <a onClick={() => resetSteps()}>繼續複製下一筆</a>
                        </p>
                      </>
                    )}
                  />
                )
                : (
                  <Countdown
                    key={proposalId}
                    seconds={3}
                    onFinish={() => {
                      window.location.href = `/proposal/newListing/compose?id=${proposalId}`
                    }}
                  >
                    {remaining => (
                      <b>
                        {`即將在 ${remaining} 秒後導向提案頁面`}
                      </b>
                    )}
                  </Countdown>
                )}
            </div>
          </>
        )}
      </div>
    </ExternalErrorStep>
  )
}

export default ExternalProposalCreateStep
